import { axios } from '@/utils/request'

const api = {
  data: '/home/data',
  getAllCategoryList: '/appletCbe/sceneRoster/getAllCategoryList',
  getBrandCategoryList: '/appletCbe/brand/getBrandCategoryList',
  getBrandCategoryListUrl: '/appletCbe/search/getBrandCategoryList',
  pageAllProductList: '/appletCbe/search/pageAllProductList',
  FWSpageAllProductList: '/info/Applet/ProviderList',
  getSupplyDemandListst: '/info/getSupplyDemandList',
  getOriginList: '/appletCbe/search/getOriginList',
  getSearchBrandCategoryList: '/appletCbe/search/getBrandCategoryList',
  getWiseManType: '/appletCbe/wiseMan/getWiseManType',
  getPlatformType: '/appletCbe/wiseMan/getPlatformType',
  getFactory: '/info/getFactory',
  findCooperationType: '/info/findCooperationType',
  adGetList: '/appletCbe/advert/getList',
  getNewsPageList: '/appletCbe/baseInfo/getPageList',
  getScaleList: '/info/getScaleList',
  getRegionList: '/info/getRegionList',
  aliTranslate: '/appletCbe/translate/aliTranslate',
  // findCooperationType: '/info/findCooperationType',
  // CPpageAllProductList: '/appletCbe/search/pageAllProductList',
}
export function aliTranslate (data) {
  return axios({
    url: api.aliTranslate ,
    method: 'post',
    data
  })
}

export function getRegionList () {
  return axios({
    url: api.getRegionList ,
    method: 'get',
  })
}

export function getScaleList () {
  return axios({
    url: api.getScaleList ,
    method: 'get',
  })
}
export function getNewsPageList (data) {
  return axios({
    url: api.getNewsPageList ,
    method: 'post',
    data
  })
}

export function adGetList (type) {
  return axios({
    url: api.adGetList + '/' + type ,
    method: 'get',

  })
}

export function getFactory (data) {
  return axios({
    url: api.getFactory ,
    method: 'post',
    data
  })
}

export function findCooperationType () {
  return axios({
    url: api.findCooperationType ,
    method: 'get',
  })
}

export function getWiseManType () {
  return axios({
    url: api.getWiseManType ,
    method: 'get',
  })
}

export function getPlatformType () {
  return axios({
    url: api.getPlatformType ,
    method: 'get',
  })
}

export function getOriginList () {
  return axios({
    url: api.getOriginList ,
    method: 'get',
  })
}

export function getSearchBrandCategoryList (type) {
  return axios({
    url: api.getSearchBrandCategoryList  + "/" + type,
    method: 'get',
  })
}

export function getSupplyDemandListst (data) {
  return axios({
    url: api.getSupplyDemandListst,
    method: 'post',
    data
  })
}
export function FWSpageAllProductList (data) {
  return axios({
    url: api.FWSpageAllProductList,
    method: 'post',
    data
  })
}
export function pageAllProductList (data) {
  return axios({
    url: api.pageAllProductList,
    method: 'post',
    data
  })
}

export function getBrandCategoryList (params) {
  return axios({
    url: api.getBrandCategoryList,
    method: 'get',
    params
  })
}

export function getBrandCategoryListUrl (params) {
  return axios({
    url: api.getBrandCategoryListUrl + '/' + params,
    method: 'get'
  })
}

export function getAllCategoryList (params) {
  return axios({
    url: api.getAllCategoryList,
    method: 'get',
    params
  })
}


/**
 * 后台首页
 * @param {*} params
 */
export function data (params) {
  return axios({
    url: api.data,
    method: 'get',
    params
  })
}
